import React from 'react';
import { Image, StyleSheet, View } from 'react-native';

import SettingsCogPng from '../../../assets/header/settings-cog.png';
import { testProps } from '../../../config';
import { goldGlow } from '../../../shared/glowStyles';
import { TouchableOpacity } from '../../Components/common/Touchable';

type MenuButtonProps = {
	onPress: () => void;
};

// Figma "Settings Button" (1867:21396): a 26x26 gold cog, 0.5 below the button's centre, with a
// 0 4 4 rgba(0,0,0,.25) drop shadow. The shadow is baked into settings-cog.png, which is the cog
// on a 42x42 canvas so the shadow has room; the cog sits in its middle 26.
const COG_CANVAS = 42;

const MenuButton = ({ onPress }: MenuButtonProps) => {
	return (
		<TouchableOpacity style={styles.button} onPress={onPress} {...testProps('cta-nav-menu')}>
			<View style={styles.buttonInner}>
				<Image source={SettingsCogPng} style={styles.cog} resizeMode='contain' />
			</View>
		</TouchableOpacity>
	);
};

const styles = StyleSheet.create({
	// Figma "Top Bar" / "Actions" (3618:68818): the notification and settings buttons are 44x43.
	button: {
		width: 44,
		height: 43,
		alignItems: 'center',
		justifyContent: 'center',
	},
	buttonInner: {
		width: 44,
		height: 43,
		borderRadius: 21.5,
		borderWidth: 1,
		borderColor: '#F5C747',
		backgroundColor: '#290908E0',
		alignItems: 'center',
		justifyContent: 'center',
		...goldGlow,
	},
	// Positioned inside the 1pt border: centred across the 42 wide inside, and 0.5 below centre
	// down the 41 high inside, which puts the canvas top at 0.
	cog: {
		position: 'absolute',
		left: (44 - 2 - COG_CANVAS) / 2,
		top: (43 - 2 - COG_CANVAS) / 2 + 0.5,
		width: COG_CANVAS,
		height: COG_CANVAS,
	},
});

export default MenuButton;
